import Size from "shared/enums/Size";
import ToolTip from "shared/components/tooltip";
import { useCopies } from "shared/hooks/useCopies";
import { useStaticData } from "context/staticData";
import { getFormattedCurrency } from "shared/utils";
import PurchaseOrderTable from "../purchaseOrderTable";
import { PurchaseOrderDetailsPropTypes } from "../types";
import { useRegDetail } from "shared/context/regDetail";
import { isRegPortal } from "shared/utils/config";
import Button from "shared/components/button";

function PurchaseOrderDetails(props: PurchaseOrderDetailsPropTypes) {
  const copies = useCopies();
  const staticDataObj = useStaticData();
  const { name: registrationName } = useRegDetail();
  return (
    <div className="paymentSummaryList">
      <div className="paymentSummaryList_header">
        <div className="paymentSummaryList_headerGroup">
          <h3 className="paymentSummaryList_header--title">{props.title || copies.get("summary")}</h3>
          {props.purchaseOrder?.identifier && (
            <p className="paymentSummaryList_header--orderId">
              <span className="paymentSummaryList_header--orderId_label">
                {copies.get("purchase.order.identifier")}
              </span>
              {props.purchaseOrder.identifier}
            </p>
          )}
        </div>

        {isRegPortal && <p className="paymentSummaryList_header--regName">{registrationName}</p>}
      </div>

      <ul className="paymentSummaryList_body">
        {props.purchaseOrder?.lines?.map(item => (
          <li key={item.purchaseOrderLineId} className="paymentSummaryList_item">
            <div className="paymentSummaryList_itemDetails">
              <p className="paymentSummaryList_itemDetails--ticket">
                {`${staticDataObj.inventoryType[item.lineType]}`}
                {Boolean(item.quantity) && (
                  <span className="paymentSummaryList_itemDetails--ticketQty">x {item.quantity}</span>
                )}
                {props.editClickHandler && <Button.Edit label={""} onClick={props.editClickHandler} />}
              </p>
              {props.originatingFormName && (
                <p className="paymentSummaryList_itemDetails--formName">{props.originatingFormName}</p>
              )}
              {item.couponCode && (
                <p className="buyInventory_coupon">
                  {copies.get("coupon")}: <span className="buyInventory_coupon--value">{item.couponCode}</span>
                </p>
              )}
            </div>
            <div className="paymentSummaryList_itemAmount">
              <p className="paymentSummaryList_itemAmount--value">{getFormattedCurrency(item.totalAmount)}</p>
            </div>
          </li>
        ))}
      </ul>
      <ul className="paymentSummaryList_footer">
        <li className="paymentSummaryList_grandTotal">
          <div className="paymentSummaryList_grandTotal--details">
            <p className="paymentSummaryList_grandTotal--detailsHeading">{copies.get("total.amount")}</p>
            <ToolTip
              offSetX={-300}
              size={Size.SMALL}
              placement="bottom"
              overlayClassName="paymentSummaryList_grandTotal--detailsTooltip"
              content={
                <PurchaseOrderTable
                  title={copies.get("details")}
                  purchaseOrder={props.purchaseOrder}
                  originatingFormName={props.originatingFormName}
                />
              }>
              <Button.Link label={copies.get("details")} />
            </ToolTip>
          </div>
          <p className="paymentSummaryList_grandTotal--amount">{getFormattedCurrency(props.purchaseOrder?.amount)}</p>
        </li>
      </ul>
    </div>
  );
}

export default PurchaseOrderDetails;
